/**
 * Hariom ERP - Production store (persisted, starts empty).
 * Employees create the real production orders.
 */
import { createCrudStore } from './createCrudStore'

export interface ProdOrder {
  id: string
  orderNo: string
  product: string
  planned: number
  actual: number
  status: string   // planned | in_progress | completed | on_hold | cancelled
  start: string
  end: string
  supervisor: string
}

export const useProductionStore = createCrudStore<ProdOrder>('hariom-erp-production')
